import { formatDate } from "../format"
import type { Availability } from "../types"
import { Icon } from "./Icon"

export function Loading({ label, compact = false }: { label: string; compact?: boolean }) {
    return <div className={`ah-loading ${compact ? "is-compact" : ""}`} role="status"><span /><strong>{label}</strong></div>
}

export function Unavailable({ availability }: { availability: Availability }) {
    const messages: Record<string, string> = {
        NO_INVENTORY: availability.availableQuantity > 0 ? `Only ${availability.availableQuantity} unit${availability.availableQuantity === 1 ? " is" : "s are"} available for these dates.` : "All units are booked for these dates.",
        DELIVERY_DATE_BLOCKED: "Delivery is not available on the derived delivery date.",
        COLLECTION_DATE_BLOCKED: "Collection is not available on the derived collection date.",
        DELIVERY_CAPACITY_EXHAUSTED: "All delivery slots are booked for that date.",
        COLLECTION_CAPACITY_EXHAUSTED: "All collection slots are booked for that date.",
    }
    return <section className="ah-unavailable" aria-live="polite"><strong>{messages[availability.reasonCode || ""] || "This hire is not available."}</strong>{availability.alternatives && availability.alternatives.length > 0 && <div className="ah-alternatives">{availability.alternatives.map((item) => <span key={item.deliveryDate}>{formatDate(item.deliveryDate)}</span>)}</div>}</section>
}

export function SupportLinks({ phone, whatsapp }: { phone: string; whatsapp: string }) {
    if (!phone && !whatsapp) return null
    return <div className="ah-support-links">{phone && <a href={`tel:${phone.replace(/\s/g, "")}`}>Call {phone}</a>}{whatsapp && <a href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer">WhatsApp</a>}</div>
}

export function AvailabilityContinueLabel({ checking }: { checking: boolean }) {
    if (checking) return <ButtonSpinner label="Checking availability" />
    return <span className="ah-continue-content" aria-live="polite" aria-atomic="true">
        <span className="ah-continue-lock" aria-hidden="true"><Icon name="lock" /></span>
        <span>Continue to Delivery & Payment</span>
        <span className="ah-continue-arrow" aria-hidden="true"><Icon name="arrow-right" /></span>
    </span>
}

export function ButtonSpinner({ label = "Preparing checkout" }: { label?: string }) {
    return <><span className="ah-continue-spinner" aria-hidden="true" /><span className="ah-visually-hidden">{label}</span></>
}
